module.exports = __webpack_public_path__ + "img/firstHistory-icon1.91a9a44b.png";